import TomSelect from 'tom-select';

jQuery(document).on('gform_post_render', function () {
  document
    .querySelectorAll('.member-add-user__form select')
    .forEach((select) => {
      if (!select.tomselect) {
        new TomSelect(select);
      }
    });
});
